import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Error {
    status: boolean;
    message: string;
}

export interface Invoices {
  errors: Error;
}

@Module
export default class InvoiceModule extends VuexModule implements Invoices {
  errors = {} as Error;
  invoices = [];
  invoice = [];
  pdf = "";

  get currentInvoices() {
    return this.invoices;
  }

  get currentInvoice() {
    return this.invoice;
  }

/*  get currentPdf() {
    return this.pdf;
  }*/

  /**
   * Get cat errors
   * @returns array
   */
  get getInvoicesErrors() {
    if (JSON.stringify(this.errors) === "{}") {
      this.errors.status = true;
      this.errors.message = "";
    }
    return this.errors;
  }

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors.status = error.status;
    this.errors.message = error.message;
    if (typeof error.errors !== "undefined") {
      let txt = "";
      const size = Object.keys(error.errors).length;
      if (size > 0) {
        Object.keys(error.errors).forEach(function (key) {
          txt += error.errors[key] + "<br />";
        });
        this.errors.message = txt;
      }
    }
  }

  @Mutation
  [Mutations.SET_INVOICES](data) {
    this.invoices = data;
  }

  @Mutation
  [Mutations.SET_INVOICE](data) {
    this.invoice = data.data;
  }

  /*@Mutation
  [Mutations.SET_PDF_LINK](data) {
    this.pdf = data.pdf;
  }*/

  @Action
  [Actions.EDIT_INVOICE](credentials) {
    return ApiService.post("admin/editInvoice", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.GET_INVOICES](credentials) {
    return ApiService.get("admin/invoice", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_INVOICES, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.GET_INVOICE](credentials) {
    return ApiService.get(`admin/invoice`, credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_INVOICE, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.DOWNLOAD_INVOICE](credentials) {

    return ApiService.post('admin/invoice/download-fish',credentials,{ responseType: 'blob' })
        .then(response => {

          const url = window.URL.createObjectURL(new Blob([response.data]))

          const link = document.createElement('a')

          link.href = url
          let file_name = 'invoice.jpeg';
          if(response.headers['content-type'] === 'image/png') file_name = 'invoice.png';
          if(response.headers['content-type'] === 'image/jpg') file_name = 'invoice.jpg';
          if(response.headers['content-type'] === 'application/pdf') file_name = 'invoice.pdf';

          link.setAttribute('download', file_name)

          document.body.appendChild(link)

          link.click()

          link.remove()

        })
        .catch(error => {
          this.context.commit(Mutations.SET_ERROR, error.response?.data || "An error occurred while downloading the file.");
        });
  }

  @Action
  [Actions.EXPORT_INVOICE](credentials) {

    return ApiService.post('admin/invoice/export',credentials,{ responseType: 'blob' })
        .then(response => {

          const url = window.URL.createObjectURL(new Blob([response.data]))

          const link = document.createElement('a')

          link.href = url
          let file_name = 'export_invoice.xlsx';
          link.setAttribute('download', file_name)

          document.body.appendChild(link)

          link.click()

          link.remove()

        })
        .catch(error => {
          this.context.commit(Mutations.SET_ERROR, error.response?.data || "An error occurred while downloading the file.");
        });
  }


  @Action
  [Actions.ACCEPT_INVOICE](credentials) {
    return ApiService.post("admin/invoice/accept", credentials)
      .then(({ data }) => {
        this.context.commit(Mutations.SET_ERROR, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, response.data);
      });
  }

  @Action
  [Actions.REJECT_INVOICE](credentials) {
        return ApiService.post("admin/invoice/reject", credentials)
            .then(({ data }) => {
                this.context.commit(Mutations.SET_ERROR, data);
            })
            .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data);
            });
    }

    @Action
    [Actions.ADD_MANUAL_INVOICE](credentials) {
        return ApiService.post("admin/invoice/manual", credentials)
            .then(({ data }) => {
                this.context.commit(Mutations.SET_ERROR, data);
            })
            .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data);
            });
    }
}
